import { EnvironmentError, IntegrationError } from './types';

export const parseEnvironmentError = (
  error: any,
): EnvironmentError | undefined => {
  if (!error) {
    return undefined;
  }
  const responseData = error?.response?.data;
  const extra = responseData?.extra;

  // Handle multi-project errors (dbt_errors map)
  const dbtErrorsByDbSchemaKey = extra?.dbt_errors as
    | Record<string, string>
    | undefined;
  const allProjectsFailed = extra?.all_failed as boolean | undefined;
  const dbtErrors = {
    dbtErrorsByDbSchemaKey,
    allProjectsFailed,
  };
  return {
    message: (responseData?.error_message as string) || 'Error',
    dbtErrors,
  };
};

export const parseIntegrationError = (
  error: any,
): IntegrationError | undefined => {
  if (!error) {
    return undefined;
  }
  const responseData = error?.response?.data;
  if (responseData?.elementary_error_code != null) {
    return {
      message:
        (responseData?.extra?.error_title as string) ||
        (responseData?.error_message as string) ||
        'Connection error',
      integrationError:
        (responseData?.extra?.integration_error as string) ||
        (responseData?.extra?.error as string) ||
        null,
    };
  }

  if (responseData?.detail != null) {
    const message = (responseData.detail || [])
      .map((item: { msg?: string; loc?: string[] }) => {
        const fieldName = item?.loc?.at(-1);
        return fieldName ? `${fieldName}: ${item?.msg}` : item?.msg;
      })
      .join(' - ');

    return { message };
  }

  return undefined;
};
